import { ValueOf } from '../utils/typeUtil';

/**
 * dodaサイトドメイン
 */
export const DODA_SITE_DOMAIN = {
  Production: 'https://doda.jp',
  development: 'http://localhost:3000',
  ST: 'https://test-st.doda.jp',
  Staging: 'https://test-staging.doda.jp',
  UAT: 'https://test-uat.doda.jp',
  TestEnv03: 'https://test-testenv03.doda.jp',
  TestEnv04: 'https://test-testenv04.doda.jp',
  TestEnv05: 'https://test-testenv05.doda.jp',
  TestEnv06: 'https://test-testenv06.doda.jp',
  TestEnv07: 'https://test-testenv07.doda.jp',
  TestEnv08: 'https://test-testenv08.doda.jp',
  'TestEnv08-2': 'https://test-testenv08-2.doda.jp',
  TestEnv10: 'https://test-testenv10.doda.jp',
} as const;

/**
 * dodaサイトの画面URL
 */
export const DODA_SITE_URL = {
  jobSearchDetail: '/DodaFront/View/JobSearchDetail.action',
  jobSearchList: '/DodaFront/View/JobSearchList.action',
  jobSearchTop: '/DodaFront/View/JobSearchTop.action',
  recommendJobList: '/DodaFront/View/RecommendJobList.action',
  seminarList: '/DodaFront/View/SeminarList.action',
  seminarDetail: '/DodaFront/View/SeminarDetail.action',
  newJobList: '/DodaFront/View/NewJobList.action',
  jobHistoryList: '/DodaFront/View/JobHistoryList.action',
  routeList: '/DodaFront/View/RouteList.action',
  stationList: '/DodaFront/View/StationList.action',
  intentionJobList: '/DodaFront/View/IntentionJobList.action',
  careerRecommendJobList: '/DodaFront/View/CareerRecommendJobList.action',
  qualificationList: '/DodaFront/View/QualificationList/',
  featuredJobList: '/DodaFront/View/FeaturedJobList.action',
  matchJobList: '/DodaFront/View/MatchJobList.action',
  conditionChange: '/DodaFront/View/ConditionChange.action',
  crossOriginAuth: '/web/cross-origin-auth',
  loginScreen: '/dcfront/login/login/',
  logout: ' /dcfront/login/logout/',
  settings: ' /dcfront/mypage/mypageRegistSetting/',
  webResume: '/dcfront/mypage/mypageWebResume/',
  educationRegist: '/dcfront/personal/educationRegist/',
  languageLicenceRegist: '/dcfront/personal/languageLicenceRegist/',
  selfPrRegist: '/dcfront/personal/selfPrRegist/',
  personalSkillRegist: '/dcfront/personal/personalSkillRegist/',
  jobSummaryRegist: '/dcfront/personal/jobSummaryRegist/',
  personalWorkExperienceRegist:
    '/dcfront/personal/personalWorkExperienceRegist/',
  logoutWebResume:
    '/dcfront/login/login/?url=%2Fdcfront%2Fmypage%2FmypageWebResume%2F',
  registration:
    '/dcfront/member/memberRegist/?entry_id=26&carry_id=5000000509&carry_class=k',
  savedConditionList: '/dcfront/condition/conditionList/',
  jobTrend: '/DodaFront/View/JobContent/JobTrend.action',
  precounseling: '/dcfront/referredJob/precounseling/',
  resumePreview: '/dcfront/mypage/resumePreview/',
  resumeFeedback: '/dcfront/mypage/resumeFeedback/',
  referredJobList: '/dcfront/referredJob/referredJobList/',
  historyList: '/dcfront/history/historyList',
  jobRanking: '/DodaFront/View/JobContent/JobRanking.action',
  company: '/DodaFront/View/Company.action',
  occupation: '/DodaFront/View/JobContent/Occupation.action',
  error: '/dcfront/error/error/',
  reloadError: '/dcfront/error/reloadError/',
  systemError: '/dcfront/error/systemError/',
  memberComplete: '/dcfront/member/memberComplete/',
} as const;

export type DodaSiteUrlValue = ValueOf<typeof DODA_SITE_URL>;

export type DodaSitePageName = keyof typeof DODA_SITE_URL;

/**
 * レコメンド URL
 */
export const RECOMMEND_LIST_URL = {
  Ranking_view_hopeL_location_income_new: '/DodaFront/View/MatchJobList.action',
  User_Entry_New: '/kyujin/recommend/User_View_OcL.html',
  AWS_Recommend_oubo: '/kyujin/recommend/ranking2.html',
  User_Entry: '/kyujin/recommend/User_View_OcL.html',
  User_View_New: '/kyujin/recommend/User_View_OcL.html',
  AWS_Recommend_etsuran: '/kyujin/recommend/ranking2.html',
  User_View: '/kyujin/recommend/User_View_OcL.html',
  view_list: '/DodaFront/View/JobHistoryList.action',
  bookmark_list: '/dcfront/bookmark/bookmarkList/',
  ranking_ocl_income: '/kyujin/recommend/ranking1.html',
  ranking_ocl: '/kyujin/recommend/ranking1.html',
  ranking_all: '/kyujin/recommend/ranking3.html',
  AWS_recommend: '/DodaFront/View/IntentionJobList.action',
  WelcomeMatch: '/dcfront/bookmark/welcomeMatchList/',
  newjob_list: '/DodaFront/View/NewJobList.action',
  WelcomeMatch_Obodash: '/kyujin/recommend/applicants_welcome_dash.html',
  WelcomeMatch_Obodash_a: '/kyujin/recommend/applicants_welcome_dash.html',
  WelcomeMatch_Obodash_b: '/kyujin/recommend/applicants_welcome_dash.html',
  Recommend_willcan: '/kyujin/recommend/ranking2.html',
  B4R_willcan: '/kyujin/recommend/ranking2.html',
  kensaku_list: '',
  syokusyu_tuukakyujin_no: '',
  syokusyu_tuukakyujin_kibou: '',
  b4r_cbm_gousei_rerank_recommend: '',
};

/**
 * doda 写真表示APIドメイン
 */
export const DODA_PHOTO_DISPLAY_API_DOMAIN = {
  Production: 'https://src.doda.jp',
  development: 'http://localhost:3000',
  ST: 'https://test-st.doda.jp',
  Staging: 'https://test-src.doda.jp',
  UAT: 'https://test-uat.doda.jp',
  TestEnv03: 'https://test-testenv03.doda.jp',
  TestEnv04: 'https://test-testenv04.doda.jp',
  TestEnv05: 'https://test-testenv05.doda.jp',
  TestEnv06: 'https://test-testenv06.doda.jp',
  TestEnv07: 'https://test-testenv07.doda.jp',
  TestEnv08: 'https://test-testenv08.doda.jp',
  'TestEnv08-2': 'https://test-testenv08-2.doda.jp',
  TestEnv10: 'https://test-testenv10.doda.jp',
} as const;

/**
 * ホスト名とCDNとの紐づけ
 * SP版のStagingは環境変数で判別できないため、ホスト名で判別する。
 */
export const HOST_TO_IMAGE_ORIGIN = {
  'doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.Production,
  'test-st.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.ST,
  'test-staging.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.Staging,
  'test-uat.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.UAT,
  'test-testenv03.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.TestEnv03,
  'test-testenv04.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.TestEnv04,
  'test-testenv05.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.TestEnv05,
  'test-testenv06.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.TestEnv06,
  'test-testenv07.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.TestEnv07,
  'test-testenv08.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.TestEnv08,
  'test-testenv08-2.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN['TestEnv08-2'],
  'test-testenv10.doda.jp': DODA_PHOTO_DISPLAY_API_DOMAIN.TestEnv10,
};

export type RecommendTypes = keyof typeof RECOMMEND_LIST_URL;

/**
 * dodaID環境別ドメイン
 */
export const DODA_COMMON_DOMAIN = {
  Production: 'https://common.doda.jp',
  ST: 'https://test-st-common.doda.jp',
  Staging: 'https://test-staging-common.doda.jp',
  UAT: 'https://test-uat-common.doda.jp',
  TestEnv03: 'https://test-testenv03-common.doda.jp',
  TestEnv05: 'https://test-testenv05-common.doda.jp',
  TestEnv07: 'https://test-testenv07-common.doda.jp',
  TestEnv10: 'https://test-testenv10-common.doda.jp',
} as const;

export const DODA_ID_EXPLANATION_HOST_DOMAIN = {
  // Production
  'doda.jp': DODA_COMMON_DOMAIN.Production,
  // local
  'localhost:3000': DODA_COMMON_DOMAIN.ST,
  // staging
  'test-staging.doda.jp': DODA_COMMON_DOMAIN.Staging,
  // staging2
  'test-staging2.doda.jp': DODA_COMMON_DOMAIN.Staging,
  // st
  'test-st.doda.jp': DODA_COMMON_DOMAIN.ST,
  // st2
  'test-st2.doda.jp': DODA_COMMON_DOMAIN.ST,
  // uat
  'test-uat.doda.jp': DODA_COMMON_DOMAIN.ST,
  // env03
  'test-testenv03.doda.jp': DODA_COMMON_DOMAIN.ST,
  // env04
  'test-testenv04.doda.jp': DODA_COMMON_DOMAIN.ST,
  // env05
  'test-testenv05.doda.jp': DODA_COMMON_DOMAIN.TestEnv05,
  // env06
  'test-testenv06.doda.jp': DODA_COMMON_DOMAIN.ST,
  // env07
  'test-testenv07.doda.jp': DODA_COMMON_DOMAIN.TestEnv07,
  // env10
  'test-testenv10.doda.jp': DODA_COMMON_DOMAIN.TestEnv10,
};

/**
 * cross-origin-authの環境別ドメイン
 */
export const AUTH_CROSSORIGIN_AUTH_ORIGIN = {
  'doda.jp': DODA_COMMON_DOMAIN.Production,
  'test-st.doda.jp': DODA_COMMON_DOMAIN.ST,
  'test-staging.doda.jp': DODA_COMMON_DOMAIN.Staging,
  'test-uat.doda.jp': DODA_COMMON_DOMAIN.UAT,
  'test-testenv03.doda.jp': DODA_COMMON_DOMAIN.TestEnv03,
  'test-testenv04.doda.jp': DODA_COMMON_DOMAIN.ST,
  'test-testenv05.doda.jp': DODA_COMMON_DOMAIN.TestEnv05,
  'test-testenv06.doda.jp': DODA_COMMON_DOMAIN.ST,
  'test-testenv07.doda.jp': DODA_COMMON_DOMAIN.TestEnv07,
  'test-testenv10.doda.jp': DODA_COMMON_DOMAIN.TestEnv10,
  'localhost:3000': DODA_COMMON_DOMAIN.ST,
};

const APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST = {
  trackerId: '23d0w4s9',
  baseUrl: 'https://galu.adj.st/',
  appDeepLinkScheme: 'doda-app-adjust-dev://?page=jobDetail',
} as const;

export const APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG = {
  Production: {
    trackerId: '22kogugr',
    baseUrl: 'https://r49z.adj.st/',
    appDeepLinkScheme: 'doda-app-adjust://?page=jobDetail',
  },
  development: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  ST: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  Staging: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  UAT: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  TestEnv03: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  TestEnv04: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  TestEnv05: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  TestEnv06: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  TestEnv07: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  TestEnv08: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  'TestEnv08-2': APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
  TestEnv10: APP_USAGE_PROMOTION_MODAL_ADJUST_CONFIG_TEST,
} as const;
